import script from "./ListingSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ListingSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ListingSkeleton.vue?vue&type=style&index=0&id=7c845494&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c845494"]])

export default __exports__